// extracted by mini-css-extract-plugin
module.exports = {"container":"StepIndicator_container__2dPq0","steps":"StepIndicator_steps__2eW7p","round":"StepIndicator_round__1Oh-j","round__active":"StepIndicator_round__active__1qILc"};